import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { PageContainer } from '@/components/layout/PageContainer';
import { ArrowRight } from 'lucide-react';

export default function OnboardingSuccessPage() {
  return (
    <PageContainer className="max-w-md mx-auto py-6">
      <div className="space-y-6 py-8">
        <h1 className="font-display text-2xl text-foreground leading-tight">
          Tack för ditt intresse
        </h1>
        <p className="text-sm text-muted-foreground leading-relaxed">
          Vi återkommer via e-post när vi har läst igenom er ansökan.
        </p>
        <Button asChild className="w-full h-11">
          <Link to="/app/customer?interest=1">
            Tillbaka till översikten
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </div>
    </PageContainer>
  );
}
